import { format } from 'date-fns';
import { DATE_FNS_DB_FORMAT, DATE_TIME_FNS_DB_FORMAT } from '@core/localization/localization.constants';


export const convertDateTimeToDbFormat: (date: Date | string, time?: Date | string) => string = (date: Date | string, time?: Date | string) => {
    if (time && time instanceof Date && date instanceof Date) {
        date.setHours(time.getHours(), time.getMinutes(), 0, 0);
    }

    return format(date, DATE_TIME_FNS_DB_FORMAT);
};

export const convertDateToDbFormat: (date: Date | string) => string = (date: Date | string) => {
    return format(date, DATE_FNS_DB_FORMAT);
};

export const convertDateTimeToSeconds: (date: Date | string) => number = (date: Date | string) => {
    date = new Date(date);

    return date.getHours() * 3600 + date.getMinutes() * 60;
};
